import Carousel, { HTMLCarouselElement } from '@/js/App/Carousel/Carousel'
import { Control } from '@peckadesign/pd-naja/dist/types'

class CarouselControl implements Control {
	private carouselMap: Map<HTMLElement, Carousel> = new Map()

	public initialize(context: Element | Document): void {
		const carousels = context.querySelectorAll<HTMLElement>(Carousel.selector)

		carousels.forEach((carouselElement: HTMLElement) => {
			const carousel = new Carousel(carouselElement)
			this.carouselMap.set(carouselElement, carousel)
		})
	}

	public destroy(context: Element) {
		const carousels = context.querySelectorAll<HTMLCarouselElement>(Carousel.selector)

		carousels.forEach((carouselElement) => {
			const carousel = this.carouselMap.get(carouselElement)

			if (carousel) {
				carousel.destroy()
				this.carouselMap.delete(carouselElement)
			}
		})
	}
}

export default new CarouselControl()
